<div class="file-metadata-container flex flex-column gap-small">
    <div class="input-row pt-2">
        <app-select-input
            [style.minWidth.px]="200"
            [form]="form" id="kind"
            [staticOptions]="fileKindEnumOptions"
            label="inputs.document.label"
            [zIndex]="1100"
        >
        </app-select-input>
        <app-date-input
            [style.minWidth.px]="200"
            [form]="form"
            id="date"
        >
        </app-date-input>
    </div>
    <app-select-input
        [form]="form" id="categoryId"
        [staticOptions]="filterCategories()"
        label="files.dialog.category.label"
        valueKey="id"
        [zIndex]="1100"
    >
    </app-select-input>
    @if (!folderId() && store2.globalGlobalStore.organizationStore.isSettingActive(OrganizationSettingTypeEnum.HEALTHCARE_SOCIAL_SETTINGS)() && store2.isAllowed('service.read')()) {
        <app-multi-select-input
            [form]="form" id="serviceIds"
            [staticOptions]="store2.globalGlobalStore.organizationStore.servicesInContext()"
            valueKey="id"
            label="service.labelMulti"
            [dataKey]="null"
            [zIndex]="1100"
        >
        </app-multi-select-input>
    }
    <app-text-area-input [form]="form" id="note"></app-text-area-input>
</div>
